import { Reveal } from "@/components/Reveal";
import { siteConfig } from "@/data/siteConfig";

export function ProcessSteps({ light = false }) {
  return (
    <div className="grid gap-px bg-[#E3E8EF] sm:grid-cols-2 lg:grid-cols-4 border border-[#E3E8EF]" data-testid="process-steps">
      {siteConfig.process.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.08} className={`relative p-8 lg:p-10 ${light ? "bg-ink" : "bg-white"}`}>
          <span className="font-display text-5xl font-bold text-amber">{s.n}</span>
          <h3 className={`mt-4 font-display uppercase text-xl tracking-wide ${light ? "text-white" : "text-ink"}`}>{s.title}</h3>
          <p className={`mt-2 text-sm leading-relaxed ${light ? "text-white/60" : "text-muted"}`}>{s.desc}</p>
        </Reveal>
      ))}
    </div>
  );
}
